import { render, staticRenderFns } from "./KnowledgeUnitOptionTypes.vue?vue&type=template&id=65e8e1ae&"
import script from "./KnowledgeUnitOptionTypes.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitOptionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports